function Error() {
    return (<>
    <h1>404 error, page nakoo find
    ↩️  🤟  😄</h1>
    </>  
    );
}

export default Error;